<template>
  <div class="container">
    <div class="pt-4 pb-4 short-rules">
      <div v-html="$t('Footer.legalrules')" class="text-center"></div>
    </div>
  </div>
  <footer class="py-3">
    <div class="navbar px-4 py-0">
      <div class="col">
        <ul class="list-inline" id="footer-nav">
          <li class="list-inline-item">
            <router-link to="/Home" aria-label="Home" alt="Home">{{ $t('Footer.Home') }}
            </router-link>
          </li>
          <li class="list-inline-item">
            <router-link to="/ReceiptTroubleshooting" aria-label="Receipt Troubleshooting"
              alt="Receipt Troubleshooting">{{ $t('Footer.ReceiptTroubleshooting') }}
            </router-link>
          </li>
          <li class="list-inline-item" v-html="$t('Footer.T&CLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.FAQlink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.CookiePreference')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.SnippPrivacyPolicyLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.DNSLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')">
          </li>
        </ul>
        <p class="mb-0">
          {{ $t('Footer.copyrighttext') }} © {{ new Date().getFullYear() }}
            {{ $t('Footer.AllrightReserved') }}
        </p>
      </div>
      <!-- <div class="footer-right">
        <div class="footer-social-nav">
          <ul class="list-inline m-0">
            <li>{{ $t('Footer.FollowUsText') }}</li>
            <li>
              <a href="http://snipp.us/!ctv9B" class="fb-link social-icon" title="facebook" target="_blank">
                <i class="fab fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="http://snipp.us/!cuYkg" class="twitter-link social-icon" title="twitter" target="_blank">
                <i class="fab fa-x-twitter"></i>
              </a>
            </li>
            <li>
              <a href="http://snipp.us/!cuYkh" class="ig-link social-icon" title="instagram" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="#" class="yt-link social-icon" title="youtube" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}&bottom=80`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>


